//src/modules/chatbot/parts/submit.jsx
import React, {useState} from 'react';
import axios from 'axios';
import { Button } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';


const SubmitComponent = ({ userInput, setUserInput, setIsLoading, conversation, setConversation, setShowDetailComponent, setErrorMessage }) => {

  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const handleInputChange = (e) => {
    setUserInput(e.target.value);
  };

  const handleSubmit = async (e) => {

    setIsButtonDisabled(true)
    setIsLoading(true); // ローディング開始
    e.preventDefault();

    const apiBaseURL = process.env.REACT_APP_API_URL || 'https://hangul-match.com/';
    const apiUrl = `${apiBaseURL}api/checkcorrect`;
    const token = localStorage.getItem('authToken');
    const headers = {
      Authorization: `Bearer ${token}`
    };
    try {
      const response = await axios.post(apiUrl, { userInput, conversation }, { headers });
      setConversation(response.data.conversation);
      setShowDetailComponent(true);
      setUserInput('');
    } catch (error) {
      if (error.response && error.response.status === 403) {
        // エラーメッセージを表示するなど、特定の処理を行う
        console.error('Error message:', error.response.data.message);
        setErrorMessage(error.response.data.message);
        setIsLoading(false);
      } else {
        console.error('There has been a problem with your fetch operation:', error)
      }
      setUserInput('');
      setIsButtonDisabled(false);
    } finally {
      setIsLoading(false); // ローディング終了
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit} style={{ position: 'relative', margin: '10px 0px' }}>
        <div className="submitCheck">
          <input
            className="submitCheckArea"
            type="text"
            value={userInput}
            onChange={handleInputChange}
            disabled={isButtonDisabled}
            placeholder="ここに入力"
            maxLength={200} 
          />
          <Button
            variant="text"
            endIcon={<SendIcon />}
            type="submit"
            style={{
              background: '#21D65F',
              padding: '0px 20px',
              color: '#181818',
              fontWeight: 'bold',
            }}
          >
            添削
          </Button>
        </div>
      </form>

    </>
  );
}

export default SubmitComponent;